import { URLSearchParams } from '@/helpers'
import { getBaseHeader } from '@/api/services'
import getHeaders from '@/api/headersSettings'

let baseState = {
  quotation: {
    asyncPending: false,
    destinationId: null,
    codDestination: null,
    countries: [],
    countriesSelected: [],
    endDate: null,
    initialDate: null,
    numberOfPassengersFourtyYears: 0,
    numberOfPassengersSixtyFourYears: 0,
    numberOfPassengersSeventyFiveYears: 0,
    numberOfPassengersEightyFiveYears: 0,
    numberOfPassengersNinetyNineYears: 0,
    selectedQuoteUuid: '',
    promoCode: {
      value: null,
      valid: null
    },
    result: {},
    userUuid: 0,
    planCovidSelected: null,
    promoCodeExpiration: '',
    quotationUrl: '',
    insurer: '',
    hasIdOld: false,
    hasNational: false,
    isNational: false
  },
  travelSetup: {
    appSettings: {},
    countries: [],
    listDestinations: [],
    theme: 'viagem',
    promotionCiclic: {
      active: false,
      promoCode: ''
    },
    smallDiscountStamp: false,
    lead: {
      type: 'TRAVEL',
      uuid: '',
      leadName: '',
      leadEmail: '',
      leadPhone: '',
      link: '',
      url: '',
      initialDate: '',
      endDate: '',
      destination: '',
      countries: [],
      travelType: 'SINGLE_TRIP',
      destinations: []
    },
    params: {
      acceptance: false
    }
  },
  user: {
    asyncPending: false,
    invalidPassenger: false,
    optIn: false,
    passenger: false,
    passengers: [],
    voucherRecipient: {
      name: '',
      email: ''
    }
  },
  payment: {},
  additional: {
    pcr: {
      states: [],
      laboratories: null,
      listSelectedPassengers: [],
      currentValue: null,
      totalValue: null,
      loading: false,
      laboratoriesByState: [],
      stateSelected: null,
      active: false
    }
  }
}

// initialState no manipuled, initial values
// baseState manipuled, changed values
const initialState = JSON.parse(JSON.stringify(baseState))

// Verifica se existe sessão CICLIC_TRAVEL_CHECKOUT, caso não exista, seta um objeto vazio
const sessionStorageCheckout = JSON.parse(window.sessionStorage.getItem('ciclic:travel')) || {}

// Faz um merge dos dados com o baseState
baseState = Object.assign({}, baseState, sessionStorageCheckout)

const { lead_uuid: leadUuid, ...params } = URLSearchParams()

Object.assign(baseState.travelSetup.params, params)

if (leadUuid) baseState.travelSetup.lead.uuid = leadUuid

window.sessionStorage.getItem('ciclic:travel:lead') && Object.assign(
  baseState.travelSetup.lead,
  JSON.parse(window.sessionStorage.getItem('ciclic:travel:lead'))
)

getBaseHeader(getHeaders())

function initialStateByModule (module) {
  return baseState[module]
}

export { baseState, initialState, initialStateByModule }
